import * as React from 'react'
import { IVehicleDepotAddress, IVehicleObj } from '../../../types'
import FloatingForm from 'src/components/ui/form/FloatingForm'
import FormLabel from 'src/components/ui/form/FormLabel'
import serviceVehicles from 'src/services/Vehicles'
import { add, set } from 'lodash'
import { MoonLoader } from 'react-spinners'

const VehicleInfo = (props: { vehicle: IVehicleObj }) => {
  const [vehicle, setVehicle] = React.useState<IVehicleObj>(props.vehicle)
  const [address, setAddress] = React.useState<IVehicleDepotAddress | null>(null)
  const [isLoading, setIsLoading] = React.useState(true)
  const isDedicated = vehicle.isDedicated ? 'Yes' : 'No'

  React.useEffect(() => {
    serviceVehicles.fetchSingleVehicle(vehicle.id).then(res => {
      if (res.vehicle[vehicle.id]) {
        setVehicle(res.vehicle[vehicle.id])
        fetchAddress(vehicle.id)
      }
    })
  }, [])

  const addressOptions = [
    {
      value: 'operator_home_address',
      label: 'Operator Home Address'
    },
    {
      value: 'vehicles_depot_address',
      label: 'Vehicle Depot Address'
    }
  ]

  const fetchAddress = async (id: string) => {
    const address = await serviceVehicles
      .getVehicleDepotAddress(id)
      .then(data => {
        return data
      })
      .catch(error => {
        console.error('Error fetching vehicle depot address:', error)
      })
    if (address.length > 0) {
      setAddress(address[0])
      setIsLoading(false)
      return address
    } else {
      setAddress(null)
      setIsLoading(false)
      return null
    }
  }

  const selectedDefaultAddress = addressOptions.find(a => a.value === vehicle.defaultAddress)
  const selectedDefaultAddressOption = selectedDefaultAddress ? selectedDefaultAddress.label : 'None'

  return (
    <FloatingForm fullHeight={true}>
      {isLoading ? (
        <div className='w100 h100 flex justify-center items-center p4'>
          <MoonLoader sizeUnit={'px'} size={20} color={'#405264'} loading={true} />
        </div>
      ) : (
        <div className='form-modal-section main-section'>
          <div className='flex'>
            <FormLabel>Vehicle Information</FormLabel>
          </div>

          <div className='bb-shadow-grey'>&nbsp;</div>

          <div className='flex'>
            <div className='col-6'>
              <div className='flex flex-row'>
                <div style={{ flex: 1 }} className='mt1'>
                  <FormLabel>Fleet ID</FormLabel>
                  <div className='mt1 h5'>{vehicle.fleetId}</div>
                </div>
              </div>

              <div className='flex flex-row'>
                <div style={{ flex: 1 }} className='mt1'>
                  <FormLabel>License Plate</FormLabel>
                  <div className='mt1 h5'>{vehicle.licensePlate}</div>
                </div>
              </div>

              <div className='flex flex-row'>
                <div style={{ flex: 1 }} className='mt1'>
                  <FormLabel>Make</FormLabel>
                  <div className='mt1 h5'>{vehicle.make}</div>
                </div>
              </div>

              <div className='flex flex-row'>
                <div style={{ flex: 1 }} className='mt1'>
                  <FormLabel>Model</FormLabel>
                  <div className='mt1 h5'>{vehicle.model}</div>
                </div>
              </div>

              <div className='flex flex-row'>
                <div style={{ flex: 1 }} className='mt1'>
                  <FormLabel>Car Type</FormLabel>
                  <div className='mt1 h5'>{vehicle.type}</div>
                </div>
              </div>

              <div className='flex flex-row'>
                <div style={{ flex: 1 }} className='mt1'>
                  <FormLabel>Year</FormLabel>
                  <div className='mt1 h5'>{vehicle.year}</div>
                </div>
              </div>

              <div className='flex flex-row'>
                <div style={{ flex: 1 }} className='mt1'>
                  <FormLabel>Color</FormLabel>
                  <div className='mt1 h5'>{vehicle.color}</div>
                </div>
              </div>

              <div className='flex flex-row'>
                <div style={{ flex: 1 }} className='mt1'>
                  <FormLabel>Default Address</FormLabel>
                  <div className='mt1 h5'>{selectedDefaultAddressOption}</div>
                </div>
              </div>

              <div className='flex flex-row'>
                <div style={{ flex: 1 }} className='mt1'>
                  <FormLabel>Dedicated To Product</FormLabel>
                  <div className='mt1 h5'>{isDedicated}</div>
                </div>
              </div>
            </div>
            <div className='col-6'>
              {address && address.street && (
                <div className='flex flex-row'>
                  <div style={{ flex: 1 }} className='mt1'>
                    <FormLabel>Street Address</FormLabel>
                    <div className='mt1 h5'>{address.street}</div>
                  </div>
                </div>
              )}
              {address && address.city && (
                <div className='flex flex-row'>
                  <div style={{ flex: 1 }} className='mt1'>
                    <FormLabel>City</FormLabel>
                    <div className='mt1 h5'>{address.city}</div>
                  </div>
                </div>
              )}
              {address && address.state && (
                <div className='flex flex-row'>
                  <div style={{ flex: 1 }} className='mt1'>
                    <FormLabel>State</FormLabel>
                    <div className='mt1 h5'>{address.state}</div>
                  </div>
                </div>
              )}
              {address && address.zip && (
                <div className='flex flex-row'>
                  <div style={{ flex: 1 }} className='mt1'>
                    <FormLabel>Zip Code</FormLabel>
                    <div className='mt1 h5'>{address.zip}</div>
                  </div>
                </div>
              )}
              {address && address.country && (
                <div className='flex flex-row'>
                  <div style={{ flex: 1 }} className='mt1'>
                    <FormLabel>Country</FormLabel>
                    <div className='mt1 h5'>{address.country}</div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </FloatingForm>
  )
}

export default VehicleInfo



// WEBPACK FOOTER //
// ./src/components/vehicles/viewVehicle/VehicleInfo.tsx